<div class="fx-row w-full fx-justify-center fx-align-start fx-gap-2">
  <button
    mat-mini-fab
    class="shadow-1 s-9"
    color="primary"
    [disabled]="disabled"
    (click)="decrementDate()">
    <mat-icon>navigate_before</mat-icon>
  </button>
  <mat-form-field class="mat-form-field-should-float mat-form-field-has-label no-padding body-2 text-grey-400 custom-mat-form-field w-50">
    <input
      class="hidden"
      matInput
      readonly
      [disabled]="disabled"
      [formControl]="date"
      [matDatepicker]="dp"
      [max]="disableFutureDates ? maxDate : null"
      (dateChange)="setDate($event)">
    <input
      matInput
      readonly
      [(ngModel)]="selectedDate.value">
    <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
    <mat-datepicker
      #dp
      [startView]="startView"
      (monthSelected)="setMonth($event, dp)"
      (yearSelected)="setYear($event, dp)">
    </mat-datepicker>
  </mat-form-field>
  <button
    mat-mini-fab
    class="shadow-1 s-9"
    color="primary"
    [disabled]="isButtonDisabled || disabled"
    (click)="incrementDate()">
    <mat-icon>navigate_next</mat-icon>
  </button>
  <ng-content></ng-content>
</div>
